import { Grid } from '@mui/material';

import { parseAsInteger, useQueryState } from 'nuqs';
import { useTranslation } from 'react-i18next';

import LeihBar from 'assets/leihBar_Logo.svg';
import { translations } from 'locales/i18n';
import { formatToISODateWithoutTime } from 'utils/dates';
import usePageHeading from 'utils/hooks/usePageHeading';

import { ColorLegend } from '../components/ColorLegend';
import { OrderDatagrid } from '../components/OrderDatagrid';
import { DailyView } from '../leihbar.types';
import { DailyHeader } from './DailyHeader';

export const DailyOverview = () => {
  const { t } = useTranslation();
  const [startDay] = useQueryState('startday', {
    defaultValue: formatToISODateWithoutTime(new Date()),
    shallow: false
  });
  const [endDay] = useQueryState('endday', {
    defaultValue: formatToISODateWithoutTime(new Date()),
    shallow: false
  });

  const [view, setView] = useQueryState('view', {
    defaultValue: 'pickups',
    shallow: false
  });

  const [lenderGroupId] = useQueryState('lenderGroupId', parseAsInteger);

  usePageHeading({
    heading: t(translations.pages.leihbar.daily.title()),
    headingLogo: LeihBar
  });

  return (
    <Grid container style={{ height: '75vh' }} gap={1}>
      <DailyHeader tab={view} setTab={setView} />
      <OrderDatagrid
        filters={{
          startDay,
          endDay,
          withConflicts: true,
          view: view as DailyView,
          lenderGroupId
        }}
        daily
      />
      <ColorLegend />
    </Grid>
  );
};
